module.exports = __webpack_public_path__ + "img/langchao.990f7a66.png";